import { IPreloadedState } from 'shared/types/redux';

export const selectMarketTrendsData = (state: IPreloadedState) => state.marketTrends.marketTrendsData;
